import { CmsSpacingSizes } from '@tgg/common-types';

import { StyledDiv } from './withVerticalSpacing.styled';

type SpacingProperties = {
    spacingBottom?: CmsSpacingSizes;
};

export const withVerticalSpacing = <T extends SpacingProperties>(
    Component: React.ComponentType<T>,
) => {
    const ComponentToBeWrapped = (properties: T) => {
        const { spacingBottom } = properties;
        if (spacingBottom) {
            return (
                <>
                    <Component {...properties} />
                    {spacingBottom && (
                        <StyledDiv
                            $spacingBottom={spacingBottom}
                            data-testid="cmsSpacing"
                        />
                    )}
                </>
            );
        }
        return <Component {...properties} />;
    };

    const displayName = Component.displayName || Component.name;
    ComponentToBeWrapped.displayName = `withTheme(${displayName})`;

    return ComponentToBeWrapped;
};
